import React from "react";

const HeaderCheckbox = ({ indeterminate, checked, onChange, ariaLabel }) => {
   return (
      <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
         <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ marginRight: "8px" }}>
            <rect
               x="3"
               y="3"
               width="18"
               height="18"
               rx="2"
               ry="2"
               style={{ fill: checked ? "#007bff" : "none", stroke: checked ? "#007bff" : "#16191f" }}
            />
            {indeterminate && (
               <path
                  d="M7 12h10"
                  style={{ fill: "none", stroke: "#fff", strokeWidth: "2" }}
               />
            )}
            {checked && !indeterminate && (
               <path
                  d="M7 12l5 5L17 8"
                  style={{ fill: "none", stroke: "#fff", strokeWidth: "2" }}
               />
            )}
         </svg>
         <input
            type="checkbox"
            checked={checked}
            onChange={onChange}
            style={{ display: "none" }}
            aria-label={ariaLabel}
         />
      </label>
   );
};

export default HeaderCheckbox;
